export class CarouselSingle {
  constructor(Flickity) {
    document.querySelectorAll('.carousel-single').forEach(carousel => {
      this.initCarousel(carousel, Flickity);
    });
  }

  initCarousel(gallery, Flickity) {
    new Flickity(gallery, {
      arrowShape:
        'M73.75 1.676L71.947 0 26.25 50.11 71.951 100l1.799-1.68-44.165-48.214L73.75 1.676z',
      wrapAround: false,
      pageDots: false,
      setGallerySize: false,
      // resize: false,
      dragThreshold: 15,
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/carousel-single.js